import { useGetExternalOperatorDriversQuery } from '../../services/externalOperatorDrivers.endpoints';
import type { Option } from '@/components/inputs/AutocompleteInput';
import { useMemo } from 'react';

interface UseExternalOperatorDriversAutocompleteProps {
  search?: string;
  minLength?: number;
  logisticOperatorId?: string;
}

const useExternalOperatorDriversAutocomplete = ({
  search,
  minLength = 3,
  logisticOperatorId,
}: UseExternalOperatorDriversAutocompleteProps = {}) => {
  const shouldSearch = Boolean(search && search.length >= minLength);

  const { data: driversData, isLoading: isDriversLoading } =
    useGetExternalOperatorDriversQuery(
      {
        filters: {
          name: shouldSearch ? search : '',
          ...(logisticOperatorId?.trim()
            ? { assignableToRouteOperatorId: logisticOperatorId.trim() }
            : {}),
        },
        limit: 1000,
        offset: 0,
      },
      { skip: !shouldSearch }
    );

  const driverOptions: Option[] = useMemo(() => {
    if (isDriversLoading) return [];
    if (!driversData?.items) return [];

    return driversData.items.map((driver) => ({
      label: `${driver.firstName} ${driver.lastName}`.trim() || driver.id,
      data: driver.id,
    }));
  }, [isDriversLoading, driversData?.items]);

  return {
    driverOptions,
    isDriversLoading,
  };
};

export default useExternalOperatorDriversAutocomplete;
